import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabase';
import { useLanguage } from './i18n/LanguageContext';

const MENU_TEXT = {
    en: { myProfile: 'My profile', signOut: 'Sign out' },
    it: { myProfile: 'Il mio profilo', signOut: 'Esci' },
    es: { myProfile: 'Mi perfil', signOut: 'Cerrar sesión' },
    fr: { myProfile: 'Mon profil', signOut: 'Se déconnecter' },
    pt: { myProfile: 'Meu perfil', signOut: 'Sair' },
};

function ProfileMenu({ initial }) {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState(false);
    const { interfaceLanguage } = useLanguage();
    const m = MENU_TEXT[interfaceLanguage] || MENU_TEXT.en;

    const handleSignOut = async () => {
        await supabase.auth.signOut();
        navigate('/');
    };

    return (
        <div style={{ position: 'relative' }}>
            <div
                style={{
                    width: 34, height: 34, borderRadius: '50%',
                    background: 'rgba(255,255,255,0.2)',
                    border: '1.5px solid rgba(255,255,255,0.4)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 14, fontWeight: 500, cursor: 'pointer', color: 'white',
                    flexShrink: 0,
                }}
                onClick={() => setShowMenu(!showMenu)}
            >
                {initial}
            </div>

            {showMenu && (
                <>
                    <div
                        style={{
                            position: 'fixed', inset: 0, zIndex: 99,
                            WebkitTapHighlightColor: 'transparent',
                        }}
                        onTouchEnd={(e) => { e.preventDefault(); setShowMenu(false); }}
                        onClick={() => setShowMenu(false)}
                    />
                    <div style={{
                        position: 'absolute', top: 42, right: 0,
                        background: 'white', borderRadius: 12,
                        border: '0.5px solid #E5E7EB',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                        minWidth: 160, zIndex: 100, overflow: 'hidden',
                    }}>
                        <div
                            style={{
                                padding: '12px 14px', fontSize: 13, fontWeight: 500,
                                color: '#111827', cursor: 'pointer', display: 'flex',
                                alignItems: 'center', gap: 8,
                            }}
                            onClick={() => { setShowMenu(false); navigate('/profile'); }}
                            onMouseEnter={e => e.currentTarget.style.background = '#F9FAFB'}
                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                        >
                            👤 {m.myProfile}
                        </div>
                        <div style={{ height: '0.5px', background: '#E5E7EB' }}></div>
                        <div
                            style={{
                                padding: '12px 14px', fontSize: 13, fontWeight: 500,
                                color: '#A32D2D', cursor: 'pointer', display: 'flex',
                                alignItems: 'center', gap: 8,
                            }}
                            onClick={() => { setShowMenu(false); handleSignOut(); }}
                            onMouseEnter={e => e.currentTarget.style.background = '#FCEBEB'}
                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                        >
                            🚪 {m.signOut}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default ProfileMenu;